





























































































# import settings from '@/settings'
import Menus from '@/components/menus'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import d from '@/utils/imports'

export default {
    name: 'imports_upload'

    components: { Menus }

    props:
        item:
            type: String

    data: ()->
        errors: {}
        false: false
        import_data: {
            uid: ''
            is_utf8: true
            separator: ";"
            delete_all: false
            csv_name: ''
            csv_data: ''
        }
        import_set: []
        display_import_set: false
        code_content: "Type de codage de caractères"

    computed:
        company_uid: ()->
            # console.log "GETTERS IMPORT", @$store.state.selected_company.uid
            return @$store.state.selected_company.uid

        item_label: ()->
            return d[@item]['label']

    methods:
        back: ()->
            @$router.push({name:"imports", params:{item:@item}})
            return

        actual: ()->
            actual = 'actuels'
            if @item in ['companies', 'user_salaries']
                actual = 'actuelles'
            return d[@item]['label'].toLowerCase() + ' ' + actual

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        toggle_display_import_set: ()->
            # console.log "TOGGLE "
            if @import_set.length > 0
                @display_import_set = !@display_import_set
            return

        handle_file_remove: (file, fileList)->
            @$refs.csv_upload.clearFiles()
            @import_data.csv_data = ''
            @import_data.csv_name = ''
            return

        handle_file_change: (file, fileList)->
            @reset_import_data()
            # console.log "HANDLE FILE CHANGE ", file.raw.type
            is_good_ext = file.raw.type == "text/csv"

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type csv')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.import_data.csv_data = e.target.result
                self.import_data.csv_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @import_data
            return

        delete_import: (import_uid)->
            # console.log "DELETE IMPORT ", import_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce fichier d'import ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "IMPORT DELETE", import_uid
                    m.run('delete_object', ['import', import_uid])
                    .then (resp)->
                        # console.log "DELETE IMPORT", resp.body.data.import_deletion
                        if resp.body.data.import_deletion.ok
                            n.success()
                            self.get_imports()
                        else
                            n.gql_error("imports_upload: delete_import: then", resp.body.data.import_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "imports_upload: delete_import()")
                .catch (cancel)->
                    return

        download_example: (item)->
            item_dir = item+'.csv'
            self = @
            @$http({
                method: 'get',
                url: settings.media_url+item_dir,
                responseType: 'arraybuffer'
            })
            .then (resp)->
                file_name = "import_"+item+"_exemple.csv"
                # console.log "THEN file name ", file_name
                url = window.URL.createObjectURL(new Blob([resp.data]))
                link = document.createElement('a')
                link.href = url
                link.setAttribute('download', file_name)
                link.click()

        get_imports: ()->
            self = @
            # console.log "GET IMPORTS ", @item
            q.run('get_import_set', [@company_uid, @item])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("imports_upload: get_imports: then", e.message)
                else
                    # console.log "GET imports : ", resp.body.data.import_set
                    self.import_set = resp.body.data.import_set
            .catch (resp)->
                n.catch_error(resp, "imports_upload: get_imports()")
            return

        select_import: (selected_import)->
            @import_data = selected_import
            @$refs.csv_upload.clearFiles()
            # console.log "SELECT IMPORT ", @import_data.uid
            return

        cancel_import: ()->
            # console.log "CANCEL IMPORT ", @import_data.uid
            @reset_import_data()
            return

        reset_import_data: ()->
            @import_data = {
                uid: ''
                is_utf8: true
                separator: ";"
                delete_all: false
                csv_name: ''
                csv_data: ''
            }
            # console.log "RESET IMPORT ", @import_data.uid
            return

        pre_save: ()->
            self = @
            if @import_data.delete_all
                insert = ''
                if @item == 'user_salaries'
                    insert = 'te'
                h = this.$createElement
                @$confirm('', 'Confirmation', {
                    message: h('p', null, [
                        h('span', null, "Êtes-vous sûr·e de vouloir supprimer tou"+insert+"s les "+d[@item]['label']+" qui existent déjà dans l'application ?"),
                        h('br'),
                        h('span', { style: 'color: red; font-weight: bold;' }, 'Attention ! La suppression est définitive.')
                      ]),
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler'
                    })
                    .then ()->
                        self.save()
                    .catch (cancel)->
                        self.import_data.delete_all = false
                        return
            else
                @save()

        save: ()->
            # console.log "SAVE IMPORT", @import_data
            self = @
            if @import_data.uid == '' and @import_data.csv_name == ""
                n.file_error('Erreur', 'Un fichier est requis')
                return
            @import_data.company_uid = @company_uid
            @import_data.item = @item
            m.run('save_import', [@import_data])
            .then (resp)->
                if resp.body.data.import_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.import_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.import_form_mutation.errors
                    self.errors = resp.body.data.import_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    # console.log "GET NEXT STEP NEW", resp.body.data.import_form_mutation.form_ret
                    self.next_step(resp.body.data.import_form_mutation.form_ret)
            .catch (resp)->
                n.catch_error(resp, "imports_upload: save()")

        next_step: (uid)->
            @$router.push({name:"imports_configuration", params:{uid:uid, item:@item}})
            return
            
    beforeMount: ()->
        # console.log "IMPORT BEFORE MOUNT", @item
        @get_imports()
}
